import { Component, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-splash-screen',
  template: `
    <div class="splash-screen" [class.hidden]="!isLoading">
      <div class="splash-content">
        <div class="logo-container">
          <img src="./assets/datakama-logo.png" alt="Datakama" class="logo">
        </div>
        <div class="loading-container">
          <mat-spinner diameter="40" class="spinner"></mat-spinner>
          <div class="loading-dots" *ngIf="showDots">
            <span class="dot" [class.active]="dotIndex === 0"></span>
            <span class="dot" [class.active]="dotIndex === 1"></span>
            <span class="dot" [class.active]="dotIndex === 2"></span>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnDestroy {
  @Input() isLoading: boolean = true;
  @Input() showDots: boolean = true;
  
  dotIndex = 0;
  private dotsInterval: any;

  constructor() {
    // Animate dots
    this.dotsInterval = setInterval(() => {
      this.dotIndex = (this.dotIndex + 1) % 3;
    }, 500);
  }

  ngOnDestroy() {
    if (this.dotsInterval) {
      clearInterval(this.dotsInterval);
    }
  }
} 